module.exports = __webpack_public_path__ + "media/images/about/history/president-4-f9c6cf83bee9ee58d0a947506710a9a4.png";